module.exports = __webpack_public_path__ + "img/menu.8fc29add.svg";